import * as React from 'react';
import { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import { withTranslation } from 'react-i18next';
import { exportReport } from '../hooks/useReportsApi';

/**
 * Export buttons component for downloading reports as PDF or Excel
 */
function ExportButtons({ t, reportType, params = {}, testIdPrefix, onError, excelOnly = false }) {
  const [exportingPdf, setExportingPdf] = useState(false);
  const [exportingExcel, setExportingExcel] = useState(false);

  const handleExportPdf = async () => {
    setExportingPdf(true);
    try {
      await exportReport(reportType, 'pdf', params);
    } catch (error) {
      // The response is a blob, so the server's message is not readable here.
      // Hand the caller a chance to say something rather than failing silently.
      console.error('Error exporting PDF:', error);
      if (onError) onError(error, 'pdf');
    } finally {
      setExportingPdf(false);
    }
  };

  const handleExportExcel = async () => {
    setExportingExcel(true);
    try {
      await exportReport(reportType, 'xlsx', params);
    } catch (error) {
      console.error('Error exporting Excel:', error);
      if (onError) onError(error, 'xlsx');
    } finally {
      setExportingExcel(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {!excelOnly && (
      <Button
        variant="outlined"
        size="small"
        startIcon={exportingPdf ? <CircularProgress size={16} /> : <PictureAsPdfIcon />}
        onClick={handleExportPdf}
        disabled={exportingPdf}
        data-testid={testIdPrefix ? `${testIdPrefix}-pdf` : undefined}
      >
        {t('reports.exportPdf')}
      </Button>
      )}
      <Button
        variant="outlined"
        size="small"
        startIcon={exportingExcel ? <CircularProgress size={16} /> : <TableChartIcon />}
        onClick={handleExportExcel}
        disabled={exportingExcel}
        data-testid={testIdPrefix ? `${testIdPrefix}-xlsx` : undefined}
      >
        {t('reports.exportExcel')}
      </Button>
    </Box>
  );
}

export default withTranslation()(ExportButtons);
